import ApiService from "@/common/api.service";
import {
  FETCH_ADMINCONSIGNMENTS,
  PROCESS_CONSIGNMENTS,
  PROCESS_BUYS,
  UPLOAD_FILE,
  REQUEST_CONSIGNMENTMANUAL,
  REVERSE_CONSIGNMENTS
} from "../actions.type";
import { SET_ADMINCONSIGNMENTS } from "../mutations.type";

const state = {
  adminConsignments: []
};

const getters = {
  adminConsignments(state) {
    return state.adminConsignments;
  }
};

const mutations = {
  [SET_ADMINCONSIGNMENTS](context, consignments) {
    state.adminConsignments = consignments;
  }
};

const actions = {
  [FETCH_ADMINCONSIGNMENTS](context, filters) {
    return ApiService.post("admin/consignment/list", filters).then(
      adminConsignments => {
        context.commit(SET_ADMINCONSIGNMENTS, adminConsignments);
        return Promise.resolve(adminConsignments);
      }
    );
  },

  [REQUEST_CONSIGNMENTMANUAL](context, data) {
    return ApiService.post("admin/consignment/manual", data);
  },

  [PROCESS_CONSIGNMENTS](context, data) {
    return ApiService.post("admin/consignment/process", data);
  },

  [REVERSE_CONSIGNMENTS](context, data) {
    return ApiService.post("admin/consignment/reverse", data);
  },

  [PROCESS_BUYS](context, data) {
    return ApiService.postMultiPart("admin/buy/process", data);
  },

  [UPLOAD_FILE](context, data) {
    return ApiService.post("admin/uploadFile", data);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
